<template>
  <a-modal :zIndex="1000" centered :width="850" :destroyOnClose="true"
    :visible="showModal"
    title="创建课程（周期）" @cancel="handleClose" @ok="handleOk">
    <div class="create-course-container">
      <a-tabs
        :activeKey="curTab"
        tab-position="left"
        @tabClick="tabClick"
      >
        <a-tab-pane v-for="i in tabs" :key="i.key" :tab="i.text">
          <div class="pane-container scrollableBar">
            <div class="pane-tit">{{ i.text }}</div>
            <a-form-model layout="vertical"
              ref="courseForm"
              :rules="rules"
              :model="formModel"
            >
              <div class="pane-wrap" v-if="i.key === '1'">
                <a-row :gutter="20">
                  <a-col :span="12">
                    <a-form-model-item label="课程名称" prop="courseName">
                      <a-input v-model="formModel.courseName" placeholder="请输入课程名称"
                        autocomplete="off"
                        :maxLength="50"
                        allowClear
                      />
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item label="学期" prop="termId">
                      <a-select :default-value="formModel.termId" v-model="formModel.termId" placeholder="请选择学期">
                        <a-select-option :value="term.value" v-for="term in termList" :key="term.value">
                          {{ term.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="20">
                  <a-col :span="12">
                    <a-form-model-item label="课程负责人" prop="courseMasterId">
                      <a-select
                        show-search
                        v-model="formModel.courseMasterId"
                        placeholder="请输入课程负责人"
                        :default-active-first-option="false"
                        :show-arrow="true"
                        :filter-option="false"
                        :not-found-content="null"
                        :loading="teacherListLoading"
                        @search="searchTeacherList"
                        @change="handleChangeTeacher"
                        @popupScroll="getMore"
                      >
                        <a-select-option :value="teacher.userId" v-for="teacher in teacherList" :key="teacher.userId" :teacher="teacher">
                          {{ `${teacher.username || '--'}(${teacher.phone || '--'})` }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item label="自定义对外展示“老师名称”">
                      <a-input v-model="displayTeacherName" placeholder="请输入对外展示“老师名称”" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="20">
                  <a-col :span="12">
                    <a-form-model-item label="导播人员">
                      <director-selector :defaultValue="directorList" @changeDirectorList="changeDirectorList"/>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="20">
                  <a-col :span="24">
                    <a-form-model-item label="授课时间" required>
                      <course-date :courseTimeList="courseTimeList" :showDateError="showDateError" @changeTimeList="changeCourseTimeList"/>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
              <div class="pane-wrap" v-if="i.key === '2'">
                <a-row :gutter="20">
                  <a-col :span="11">
                    <a-form-model-item label="主讲学校" required>
                      <school-selector :schoolList="schoolList" :dataItem="speakerItem" @changeSchool="changeSpeakerSchool"/>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="13">
                    <a-form-model-item label="主讲教室">
                      <a-row  :gutter="20" style="display: flex;">
                        <a-col :span="21">
                          <classroom-selector :dataItem="speakerItem" @changeClassroom="changeSpeakerClassroom"/>
                        </a-col>
                      </a-row>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <div class="flex-form-item">
                  <a-row :gutter="20" >
                    <a-col :span="11">
                      <a-form-model-item label="听课学校">
                        <school-selector
                          style="margin-bottom: 10px;"
                          v-for="listenerItem in listenerList" :key="listenerItem.index"
                          :schoolList="schoolList"
                          :dataItem="listenerItem"
                          @changeSchool="changeListenerSchool"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="13">
                      <a-form-model-item label="听课教室">
                        <a-row :gutter="20" style="display: flex; margin-bottom:10px;"
                          v-for="listenerItem in listenerList" :key="listenerItem.index">
                          <a-col :span="21">
                            <classroom-selector
                              :dataItem="listenerItem"
                              @changeClassroom="changeListenerClassroom"/>
                          </a-col>
                          <a-col :span="3" class="icon-container">
                            <i :class="`icon-btn ${listenerItem.index > 0 ? 'icon-remove' : 'icon-add'}`"
                              @click="changeListenerList(listenerItem.index > 0 ? 'remove' : 'add', listenerItem.index)"></i>
                          </a-col>
                        </a-row>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </a-form-model>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-modal>
</template>

<script>
import { checkRes } from '@/utils/tool'
import { createCourse, searchUser } from '@/server/api/courseManage'
export default {
  name: 'CreateCourseModal',
  props: {
    termList: {
      type: Array,
      default() {
        return []
      }
    },
    schoolList: {
      type: Array,
      default() {
        return []
      }
    },
    showModal: Boolean
  },
  components: {
    // 'teacher-selector': () => import('./TeacherSelector'),
    // 'term-selector': () => import('./TermSelector'),
    'director-selector': () => import('./DirectorSelector'),
    'school-selector': () => import('./SchoolSelector'),
    'classroom-selector': () => import('./ClassroomSelector'),
    'course-date': () => import('./CourseDate'),
  },
  data () {
    return {
      formModel: {
        courseName: '', // 课程名称
        termId: undefined, // 学期
        courseMasterId: undefined, // 课程负责人
      },
      rules: {
        courseName: [
          { required: true, message: '请输入课程名称（限50字）', trigger: 'change' }
        ],
        termId: [
          { required: true, message: '请选择学期', trigger: 'change' }
        ],
        courseMasterId: [
          { required: true, message: '请选择课程负责人', trigger: 'change' }
        ],
        // speakerSchoolId: [
        //   { required: true, message: '请选择主讲学校', trigger: 'change' }
        // ]
      },
      curTab: '1',
      tabs: [{
        key: '1',
        text: '基础信息'
      }, {
        key: '2',
        text: '教室配置'
      }],

      displayTeacherName: '', // 对外展示“老师名称”

      teacherListLoading: false,
      teacherListRt: {},
      teacherListPageNum: 1,
      teacherListPageSize: 20,
      teacherList: [], // 老师列表

      courseMaster: {}, // 课程负责人
      directorList: [], // 导播人员
      courseTimeList: [], // 授课时间
      showDateError: false,

      speakerItem: { // 主讲学校教室
        index: 0,
        schoolId: undefined, // 主讲学校
        classroomCode: undefined, // 主讲教室
      },
      listenerList: [ // 听课学校列表
        {
          index: 0,
          schoolId: undefined,
          classroomCode: undefined
        }
      ], // 听课教室

    }
  },
  mounted() {
    this.searchTeacherList('')
  },
  methods: {
    handleChangeTeacher(value, option) {
      this.formModel.courseMasterId = value
      this.courseMaster = option.data.attrs.teacher
      this.displayTeacherName = this.courseMaster.username
    },

    tabClick(value) {
      this.curTab = value
    },
    handleOk() {
      this.$refs.courseForm[0].validate(valid => {
        if (valid) {
          if (this.directorList.find(i => i == this.formModel.courseMasterId)) {
            this.$message.error('课程负责人与导播老师不能重复！')
            return
          }
          if (!this.courseTimeList.length) {
            this.showDateError = true
            this.curTab = '1'
            return
          }
          if (!this.speakerItem.schoolId) {
            this.curTab = '2'
            return
          }
          this.goCreateCourse()
        } else {
          return false;
        }
      })
    },
    // 课程负责人
    changeCourseMaster(value) {
      this.formModel.courseMasterId = value
    },
    // 学期
    changeTerm(value) {
      this.formModel.termId = value
    },
    // 导播变化
    changeDirectorList(value) {
      this.directorList = value
    },
    // 授课时间列表
    changeCourseTimeList(value) {
      this.courseTimeList = value.map(timeObj => ({
        startTime: new Date(timeObj.startDateTime).getTime(),
        endTime: new Date(timeObj.endDateTime).getTime()
      }))
    },
    // 主讲学校变化
    changeSpeakerSchool(value) {
      this.speakerItem.schoolId = value.schoolId
    },
    // 主讲教室变化
    changeSpeakerClassroom(value) {
      this.speakerItem.classroomCode = value.classroomCode
    },
    // 听课学校变化
    changeListenerSchool(value) {
      const targetIndex = this.listenerList.findIndex(i => i.index === value.index)
      this.listenerList[targetIndex].schoolId = value.schoolId
    },
    // 听课学校、教室变化
    changeListenerClassroom(value) {
      const targetIndex = this.listenerList.findIndex(i => i.index === value.index)
      this.listenerList[targetIndex].classroomCode = value.classroomCode
    },
    // 增加删除听课学校、教室
    changeListenerList(option, index) {
      if (option === 'add') {
        this.listenerList.push({ index: this.listenerList.length, schoolId: undefined, classroomCode: undefined })
        return
      }
      if (option === 'remove') {
        const targetIndex = this.listenerList.findIndex(i => i.index === index)
        if (targetIndex < 0) return
        this.listenerList.splice(targetIndex, 1)
      }
    },
    handleClose() {
      this.$emit('close', false)
      this.curTab = '1'
      this.$refs.courseForm[0].resetFields()
      this.displayTeacherName = ''
      this.directorList = []
      this.timeList = []
      this.speakerItem = {
        index: 0,
        schoolId: undefined, // 主讲学校
        classroomCode: undefined, // 主讲教室
      }
      this.listenerList = [{
        index: 0,
        schoolId: undefined,
        classroomCode: undefined
      }]
    },
    // 新建课程
    async goCreateCourse() {
      const self = this
      const { courseName, courseMasterId, termId } = self.formModel
      const {
        displayTeacherName, directorList,  courseTimeList,
        speakerItem, listenerList
      } = self
      const res = await createCourse({
        baseCourseInfoRequest: {
          courseName: courseName,
          directorUserId: directorList,
          teacherName: displayTeacherName,
          termId,
          timeList: courseTimeList,
          userId: courseMasterId
        },
        teachClassroom: {
          classroomCode: speakerItem.classroomCode,
          schoolCode: speakerItem.schoolId
        },
        watchClassroom: listenerList
          .filter(i => !!i.schoolId)
          .map(i => ({ classroomCode: i.classroomCode, schoolCode: i.schoolId })),
      })
      checkRes({
        res,
        success(data) {
          self.$emit('refresh', false)
          self.handleClose()
          self.$message.success('创建成功')
        },
        failed(err) {
          self.$message.error('创建失败')
        }
      })
    },
    getMore(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target
      const { teacherListLoading, teacherListPageSize, teacherListPageNum, teacherListRt } = this
      if (teacherListLoading) return
      if (scrollHeight - scrollTop < clientHeight + 20) {
        if ( teacherListPageNum * teacherListPageSize < teacherListRt.totalCount) {
          this.teacherListPageNum = teacherListPageNum + 1
          this.getTeacherList()
        }
      }
    },
    searchTeacherList(keyword) {
      this.teacherListPageNum = 1
      this.getTeacherList(keyword)
    },
    // 获取当前选中机构的所有老师
    async getTeacherList(keyword) {
      const self = this
      self.teacherListLoading = true
      const res = await searchUser({
        keywords: keyword,
        pageSize: self.teacherListPageSize,
        pageNum: self.teacherListPageNum
      })
      checkRes({
        res,
        success(data) {
          self.teacherListRt = data
          if (self.teacherListPageNum > 1) {
            self.teacherList = [...self.teacherList, ...data.list]
          } else {
            self.teacherList = data.list
          }
        }
      })
      self.teacherListLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.create-course-container{
  height: 400px;
  overflow: hidden;
  .pane-container{
    height: 400px;
    overflow-y: auto;
    padding-right: 20px;
    .pane-tit{
      font-weight: bold;
      margin-bottom: 10px;
    }
    .icon-container{
      display: flex;
      align-items: center;
      .icon-btn {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: cover;
        cursor: pointer;
        &:hover{
          opacity: 0.9;
        }
        &.icon-add{
          background-image: url('../../../../img/icon-add@2x.png');
        }
        &.icon-remove{
          background-image: url('../../../../img/icon-remove@2x.png');
        }
      }
    }

  }
}
</style>